import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { User, Clock, Zap, CreditCard, Settings, LogOut } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export function UserInfoBar({ 
  user, 
  isPro, 
  isGuest, 
  localRemainingSeconds, 
  formatTime, 
  handleLogout 
}) {
  const { t } = useLanguage();
  
  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-3 mb-4 p-3 bg-zinc-900/50 rounded-lg border border-zinc-800">
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 rounded-full bg-zinc-700 flex items-center justify-center">
          <User className="w-4 h-4 text-white" />
        </div>
        <div>
          <p className="text-white text-sm font-medium">
            {user?.name === "Convidado" ? t("guest") : (user?.name || user?.email || "User")}
          </p>
          <div className="flex items-center gap-2">
            {isPro ? (
              <span className="flex items-center gap-1 text-yellow-400 text-xs">
                <Zap className="w-3 h-3" /> PRO
              </span>
            ) : isGuest ? (
              <span className="flex items-center gap-1 text-orange-400 text-xs">
                <Clock className="w-3 h-3" /> {t("guest")} - {formatTime(localRemainingSeconds)}
              </span>
            ) : (
              <span className="flex items-center gap-1 text-zinc-400 text-xs">
                <Clock className="w-3 h-3" /> {t("free")} - {formatTime(localRemainingSeconds)}
              </span>
            )}
          </div>
        </div>
      </div>
      
      <div className="flex items-center gap-2">
        {!isPro && (
          <Link to="/pricing">
            <Button size="sm" className="bg-yellow-500 hover:bg-yellow-600 text-black text-xs">
              <Zap className="w-3 h-3 mr-1" />
              {isGuest ? t("signUp") : t("upgradePro")}
            </Button>
          </Link>
        )}
        {!isGuest && (
          <Link to="/pricing">
            <Button size="sm" variant="outline" className="border-zinc-700 text-zinc-300 text-xs">
              <CreditCard className="w-3 h-3 mr-1" />
              {t("plans")}
            </Button>
          </Link>
        )}
        <Link to="/account">
          <Button 
            size="sm" 
            variant="ghost" 
            className="text-zinc-400 hover:text-white text-xs"
          >
            <Settings className="w-3 h-3 mr-1" />
            {t("account")}
          </Button>
        </Link>
        <Button 
          size="sm" 
          variant="ghost" 
          onClick={handleLogout}
          className="text-zinc-400 hover:text-white text-xs"
        >
          <LogOut className="w-3 h-3 mr-1" />
          {t("logout")}
        </Button>
      </div>
    </div>
  );
}
